import { createFileRoute } from "@tanstack/react-router";
import i18n from "@/i18n";
import { pageHead } from "@/lib/seo";
import { ProjectsPage } from "@/pages/realisaties";

export const Route = createFileRoute("/$lang/projects")({
  head: ({ params }) => {
    const lang = (params.lang as "fr" | "en") ?? "en";
    const t = i18n.getFixedT(lang, "projects");
    return pageHead({ lang, pathWithoutLang: "/realisaties", title: t("seo.title"), description: t("seo.description") });
  },
  component: ProjectsPage,
});
